import Alpine from 'alpinejs';

export function initAlpine() {
    if (!window.Alpine) {
        window.Alpine = Alpine;
    }

    Alpine.start();
}
